import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './Layers.scss'

import { shallowEqual } from 'utils/arrays'

import {
  getSelection,
  getHoverSelection,
  setLayersHover,
  setSelection,
  resetSelection,
} from 'ducks/editor/selection'

import {
  selectObject,
  getPath,
  reorderObjects,
  updateObject,
} from 'ducks/editor/objects'

import {
  getLayers,
  startDrag,
  drag,
  endDrag,
  setDropTarget,
} from 'ducks/editor/layers'

import { PanelItem } from 'components/Shared/Panel'

import { getApp } from 'ducks/apps'
import {
  getContainerFromLayoutHelper,
  isLayoutHelperSectionElement,
} from 'utils/layoutSections'
import LayerItem, { EMPTY_ARRAY } from './Item'
import DragLayer from './DragLayer'
import LayersContext from '../../../contexts/LayersContext'

class LayersMenu extends Component {
  getContext = () => ({
    getSelection: this.getSelection,
    getLayers: this.getLayers,
    execute: this.handleExecute,
    getDraggingObjects: this.getDraggingObjects,
  })

  getSelection = () => {
    const { rawSelection } = this.props

    return rawSelection
  }

  getLayers = () => {
    const { layers } = this.props

    return layers
  }

  getDraggingObjects = () => {
    const { dragLayerObjects } = this.props

    return dragLayerObjects
  }

  handleExecute = (func, ...args) => {
    // eslint-disable-next-line react/destructuring-assignment
    const funcValue = this.props[func]

    if (!funcValue) {
      throw new Error(`execute('${func}') failed: ${func} is not defined`)
    }

    return funcValue(...args)
  }

  handleAddComponent = async () => {
    const { match, history, resetSelection } = this.props
    const { appId } = match.params
    resetSelection()
    history.push(`/apps/${appId}/screens/add/component`)
  }

  shouldComponentUpdate(newProps) {
    const { objects, selection, layers } = this.props

    if (
      !shallowEqual(newProps.objects, objects) ||
      !shallowEqual(newProps.selection, selection)
    ) {
      return true
    }

    if (newProps.layers !== layers) {
      return true
    }

    return false
  }

  render() {
    const {
      layers,
      objects,
      selection,
      hoverSelection,
      dropTarget,
      dragLayerObjects,
      path,
      screenId,
    } = this.props

    const dropBefore = !layers.options.dropAfter && !layers.options.dropInside
    const dropAfter = layers.options.dropAfter
    const dropInside = layers.options.dropInside

    return (
      <LayersContext.Provider value={this.getContext()}>
        <div className="layer-items">
          {objects.length > 0 &&
            objects
              .slice()
              .reverse()
              .map((obj, i) => (
                <LayerItem
                  key={obj.id}
                  path={`${path}.${String(objects.length - i - 1)}`}
                  object={obj}
                  screenId={screenId}
                  selection={selection}
                  hoverSelection={hoverSelection}
                  dragInProgress={layers.dragging}
                  dropTarget={dropTarget}
                  dropBefore={dropBefore}
                  dropAfter={dropAfter}
                  dropInside={dropInside}
                />
              ))}
          {layers.dragging ? (
            <DragLayer
              {...layers}
              objectIds={layers.objects}
              objects={dragLayerObjects}
            />
          ) : null}
        </div>
        <PanelItem
          className="layer-item"
          title="Add Component"
          onClick={this.handleAddComponent}
          icon="plus"
          color="screens"
          uppercase
        />
      </LayersContext.Provider>
    )
  }
}

const mapStateToProps = (state, { objectId, match }) => {
  const layers = getLayers(state)
  let dragLayerObjects = EMPTY_ARRAY

  if (layers.objects && layers.objects.length > 0) {
    dragLayerObjects = layers.objects.map(id => {
      return selectObject(state, id)
    })
  }

  const object = selectObject(state, objectId)
  const path = getPath(state, objectId)
  let children = object?.children || EMPTY_ARRAY

  children = children.map(child => {
    if (isLayoutHelperSectionElement(child)) {
      return getContainerFromLayoutHelper(child)
    }

    return child
  })

  const screenId = object?.id

  const app = getApp(state, match.params.appId)
  if (app?.webSettings?.layoutMode === 'mobile') {
    children = children.filter(
      child => child.deviceVisibility?.mobile !== false
    )
  }

  return {
    layers,
    dragLayerObjects,
    objects: children,
    path,
    dropTarget: getPath(state, layers.dropTarget),
    rawSelection: getSelection(state),
    selection: getSelection(state).map(id => getPath(state, id)),
    hoverSelection: getHoverSelection(state).map(id => getPath(state, id)),
    screenId,
  }
}

const ConnectedLayersMenu = connect(mapStateToProps, {
  setLayersHover,
  setSelection,
  resetSelection,
  reorderObjects,
  updateObject,
  startDrag,
  drag,
  endDrag,
  setDropTarget,
})(LayersMenu)

export default withRouter(ConnectedLayersMenu)
